export default __webpack_public_path__ + "static/media/Shot_30.0000.68dfe2b1.png";